import React from "react";
import Countdown from "react-countdown";

const CountdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) return null;

  return (
    <div className="countdown-container">
      <strong>🎊</strong>
      <h2> Sale starts in</h2>
      <div className="time-values">
        <span>{minutes}m</span> : <span>{seconds}s</span>
      </div>
    </div>
  );
};

const CountdownTimer = ({ saleStartTime, setIsSaleStarted }) => {
  return (
    <Countdown
      date={saleStartTime}
      renderer={(props) => {
        if (props.completed) {
          setIsSaleStarted(true);
          return null;
        }
        return <CountdownRenderer {...props} />;
      }}
    />
  );
};

export default CountdownTimer;
